import actionCreatorFactory from 'typescript-fsa';
import { SiteInfo } from '../../../models/SiteInfo';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('siteInfoSubdiv');

const list = actionCreator.async<
  {
  }, // started: parameter type
  {
    Items: SiteInfo[]
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('LIST');

const clear = actionCreator('CLEAR');

export {
  list,
  clear
};



// WEBPACK FOOTER //
// ./src/redux/modules/siteInfoListSubdiv/actions.ts